import { render, staticRenderFns } from "./CandidateActions.vue?vue&type=template&id=2d2f4d87&"
import script from "./CandidateActions.vue?vue&type=script&lang=js&"
export * from "./CandidateActions.vue?vue&type=script&lang=js&"
import style0 from "./CandidateActions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports